import { apiMap } from '../utilities';
import { headerKey, restClient } from '.';

const appService = {
  getFaqs(application) {
    return restClient.makeGetRequest(apiMap.getFaqs(), {
      application,
      headers: {
        [headerKey.AuthToken]: restClient.getHeader(headerKey.AccessToken),
      },
    });
  },
  featuresEnabled({ docID, params }: { docID: any, params: { visitIds: any[]; } }) {
    return restClient.makePostRequest(apiMap.featuresEnabled(docID), params, {
      headers: {
        [headerKey.AuthToken]: restClient.getHeader(headerKey.AccessToken),
      },
    });
  },
  featuresEnabledAllDoctors(userID: string) {
    return restClient.makeGetRequest(apiMap.featuresEnabledAllDoctors(userID));
  },
};

export default appService;